import React, { Component } from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, FormGroup, Label, Input, Col
} from 'reactstrap';
import { getNovertejumsColor } from './riskaNovertejumsUtils';
import { modalFieldDefinitions } from './DzeramaUdensSatecesBaseinsAktualaSituacija';

const parsePapDati = (pap_dati) => {
    if (!pap_dati) return {};
    if (typeof pap_dati === 'object') return pap_dati;
    try { return JSON.parse(pap_dati); } catch (_e) { return {}; }
};

const getDetailFields = (item) => {
    const papDatiFields = Object.entries(parsePapDati(item.pap_dati)).map(([key, value]) => ({
        field: value, label: key, isParsedPapDati: true
    }));
    return [...papDatiFields, ...modalFieldDefinitions];
};

class VarbutibaEditModal extends Component {
    state = {
        varbutiba_eksperta: '',
        eksperta_komentars: ''
    };

    componentDidUpdate(prevProps) {
        if (this.props.item && this.props.item !== prevProps.item) {
            this.setState({
                varbutiba_eksperta: this.props.item.varbutiba_eksperta || this.props.item.varbutiba || '',
                eksperta_komentars: this.props.item.eksperta_komentars || ''
            });
        }
    }

    handleSave = () => {
        const { varbutiba_eksperta, eksperta_komentars } = this.state;
        this.props.onSave(this.props.item.id, varbutiba_eksperta, eksperta_komentars);
    }

    render() {
        const { isOpen, toggle, title, item, isEditable, showDetailFields, riskaVarbutiba } = this.props;
        if (!item) return null;

        const { varbutiba_eksperta, eksperta_komentars } = this.state;
        const originalNovertejums = item.varbutiba * item.sekas;

        return (
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody>
                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col"><Label className="field-label">Nosaukums</Label></Col>
                        <Col xs={12} md={8} className="form-col bold">{item.nosaukums_display || item.nosaukums}</Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col"><Label className="field-label">Oriģinālā varbūtība</Label></Col>
                        <Col xs={12} md={8} className="form-col">{item.varbutiba}</Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col"><Label className="field-label">Sekas</Label></Col>
                        <Col xs={12} md={8} className="form-col">{item.sekas}</Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col"><Label className="field-label">Oriģinālais novērtējums</Label></Col>
                        <Col xs={12} md={8} className="form-col">
                            <span style={{ backgroundColor: getNovertejumsColor(originalNovertejums), padding: '2px 8px', borderRadius: '3px' }}>
                                {originalNovertejums}
                            </span>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col">
                            <Label className="field-label">{isEditable ? 'Eksperta modificētā varbūtība (1-3)' : 'Eksperta varbūtība'}</Label>
                        </Col>
                        <Col xs={12} md={8} className="form-col">
                            {isEditable ? (
                                <Input type="select" value={varbutiba_eksperta} onChange={(e) => this.setState({ varbutiba_eksperta: e.target.value })}>
                                    <option value="">-- Izvēlieties --</option>
                                    {riskaVarbutiba && Object.keys(riskaVarbutiba).map(k => (
                                        <option key={k} value={k}>{riskaVarbutiba[k].nos}</option>
                                    ))}
                                </Input>
                            ) : (
                                item.varbutiba_eksperta || item.varbutiba || '-'
                            )}
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col">
                            <Label className="field-label">Eksperta komentārs{isEditable ? ' (obligāts)' : ''}</Label>
                        </Col>
                        <Col xs={12} md={8} className="form-col">
                            {isEditable ? (
                                <Input type="textarea" rows="4" value={eksperta_komentars}
                                    onChange={(e) => this.setState({ eksperta_komentars: e.target.value })}
                                    placeholder="Lūdzu, norādiet pamatojumu varbūtības izmaiņai..."
                                />
                            ) : (
                                item.eksperta_komentars || '-'
                            )}
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col">
                            <Label className="field-label">{isEditable ? 'Jaunais novērtējums' : 'Eksperta novērtējums'}</Label>
                        </Col>
                        <Col xs={12} md={8} className="form-col">
                            {isEditable && varbutiba_eksperta ? (
                                <span style={{ backgroundColor: getNovertejumsColor(varbutiba_eksperta * item.sekas), padding: '2px 8px', borderRadius: '3px' }}>
                                    {varbutiba_eksperta * item.sekas}
                                </span>
                            ) : !isEditable ? (
                                <span style={{ backgroundColor: getNovertejumsColor(item.novertejums), padding: '2px 8px', borderRadius: '3px' }}>
                                    {item.novertejums || '-'}
                                </span>
                            ) : '-'}
                        </Col>
                    </FormGroup>

                    {showDetailFields && (<>
                        <hr />
                        <h6>Papildu informācija</h6>
                        {getDetailFields(item).map(({ field, label, isParsedPapDati }, idx) => (
                            <FormGroup row key={`${label}-${idx}`}>
                                <Col xs={12} md={4} className="formlabel-col"><Label className="field-label">{label}</Label></Col>
                                <Col xs={12} md={8} className="form-col bold">
                                    {isParsedPapDati ? field ?? '-' : item[field] ?? '-'}
                                </Col>
                            </FormGroup>
                        ))}
                    </>)}
                </ModalBody>
                {isEditable && (
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>Atcelt</Button>
                        <Button color="primary" onClick={this.handleSave} disabled={!varbutiba_eksperta || !eksperta_komentars}>
                            Saglabāt
                        </Button>
                    </ModalFooter>
                )}
            </Modal>
        );
    }
}

export default VarbutibaEditModal;
